<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">How to install & update the app</div>

          <div class="card-body">
            If you’re reading this page, chances are you’ve gone past the installation part on mobile devices, or you’re doing your thing on desktop for now.<br>
            <br>
            Either way, let’s see how the installation & update processes work.<br>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Install the app<br><small>(mobile devices only)</small></h5><br>
                I have a riddle for you: what has 3 very easy steps, takes no
                more than 15 seconds and it’s super satisfying?!
                You guessed it — it’s the Expense Guide installation! What
                a shocker, right?<br>
                <br>
                It’s just too easy to spend too much time on this. So let’s
                get to it!<br>
                <br>
                <b>For iOS devices:</b><br>
                1. Open the Safari browser on your Apple device, and access app.expense.guide.<br><br>
                2. Click the Action button on the footer menu, and select “Add to Home Screen”.<br><br>
                3. Now proudly go and look for the Expense Guide logo on your Home Screen! Taa-daaa!<br><br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/add-to-home-screen-iphone.png" class="mb-4"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                Pretty much the same installation process goes for Android
                as well, but better put them separately, so they don’t get
                into a Fight Club moment all of a sudden.<br>
                <br>
                Thus, <b>for Android devices</b> it goes like this:<br>
                1. Open the Chrome browser on your Android device, and access app.expense.guide.<br><br>
                2. In a couple of seconds, you’ll be prompted with a message, inviting you to add the app to the device’s Home Screen.<br><br>
                3. All you have to do is accept, and you’ll immediately get the Expense Guide app among your other installed apps.<br><br>
                Go check it out!<br>
                <br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/add-to-home-screen-android.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Update the app<br><small>(all devices)</small></h5><br>
                If you thought the installation process was easy, wait ’til
                you see how the update goes. Blink, and you’ll miss it!!<br>
                <br>
                Ok, are you ready?<br>
                <br>
                Open the app, and, whenever you see a green square on
                the lower-left corner saying:
                <i>“New app version available. Click here to update!”</i>
                , click on it.<br>
                <br>
                That’s it! No, really, I’m not kidding, that’s really it!<br>
                <br>
                And in case you want to make sure the app truly got
                updated, you can just check the app version at the bottom
                of the Help main page.
                <br><br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/update-app.png" class="mb-2"/>
                <b-img right rounded thumbnail fluid src="/img/support/app-version.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddToHomeScreen',
  data () {
    return {}
  }
}
</script>
